export function replaceArrows(text, caretPos) {
  if (typeof text !== 'string' || text.length < 2) {
    return null;
  }

  const candidates = [
    { token: '->', symbol: '→' },
    { token: '<-', symbol: '←' },
  ];

  let chosen = null;
  candidates.forEach((c) => {
    const idx = text.lastIndexOf(c.token, Math.max(0, caretPos - 1));
    if (idx === -1) return;
    const affectsCaret = caretPos >= idx + c.token.length;
    if (affectsCaret) {
      if (chosen === null || idx > chosen.index) {
        chosen = { index: idx, symbol: c.symbol, length: c.token.length };
      }
    }
  });

  if (chosen === null) {
    return null;
  }

  const i = chosen.index;
  const newText = text.slice(0, i) + chosen.symbol + text.slice(i + chosen.length);
  const adjust = (pos) => (pos > i + chosen.length - 1 ? pos - (chosen.length - 1) : pos);
  const newCaretPos = adjust(caretPos);

  return {
    text: newText,
    newCaretPos,
    arrowIndex: i,
    adjustPosition: adjust,
  };
}
